<template>
	<div class="projectCase">
		<div v-if="banner && banner.length" class="projectCase-banner">
			<img
				:src="img.logo"
				v-for="img in banner"
				:key="img.logo"
				alt=""
				@click="openBanner(img.url)"
			/>
		</div>
		<!-- <div class="projectCase-title">
      <div class="projectCase-title-wrap">
        <template v-for="item in titleInfo">
          <el-dropdown v-if="item.value" :key="item.name" @command="handleCommand" placement="bottom">
            <span class="el-dropdown-link">
              {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="ele in item.value" :key="`${[item.key]}~${ele.id}`" :command="`${[item.key]}~${ele.id}`">{{ele.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span v-else :key="item.name" class="title" @click="handleCommand()">{{item.name}}</span>
        </template>
      </div>
    </div> -->
		<div class="projectCase-body">
			<div class="projectCase-body-wrap" v-if="serviceList.length">
				<div class="projectCase-body-wrap-title">
					专业服务
					<span class="projectCase-body-wrap-describe"
						>更多服务持续更新中...</span
					>
				</div>
				<div v-if="serviceList.length" style="padding-bottom: 20px">
					<el-row :gutter="20">
						<el-col v-for="item in serviceList" :key="item.id" :span="6">
							<ServiceCard :data="item" @show-video="handleClickShowVideo" />
						</el-col>
					</el-row>

					<!-- <div class="projectCase-pagination">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :hide-on-single-page="true"
                  :page-size="queryParam.pageSize"
                  :current-page="queryParam.pageNum"
                  :total="total"
                  @current-change="handlePageChange">
              </el-pagination>
          </div> -->
				</div>
				<EmptyPage v-else :height="588" :loading="loading" />
			</div>
			<div class="projectCase-body-wrap" v-if="solutionList.length">
				<div class="projectCase-body-wrap-title">
					解决方案
					<span class="projectCase-body-wrap-describe"
						>更多方案持续更新中...</span
					>
				</div>
				<div v-if="solutionList.length" style="padding-bottom: 20px">
					<el-row :gutter="20">
						<el-col v-for="item in solutionList" :key="item.id" :span="6">
							<ServiceCard :data="item" @show-video="handleClickShowVideo" />
						</el-col>
					</el-row>
				</div>
				<EmptyPage v-else :height="588" :loading="loading" />
			</div>
			<div class="projectCase-body-wrap">
				<div class="projectCase-body-wrap-title">
					项目案例
					<router-link
						class="projectCase-body-wrap-describe"
						target="_blank"
						as="span"
						to="/projectCase/project/case"
						>查看全部</router-link
					>
				</div>
				<div v-if="projectList.length" style="padding-bottom: 20px">
					<el-row :gutter="20">
						<el-col v-for="item in projectList" :key="item.id" :span="6">
							<ServiceCard :data="item" @show-video="handleClickShowVideo" />
						</el-col>
					</el-row>
				</div>
				<EmptyPage v-else :height="588" :loading="loading" />
			</div>
			<el-button type="primary" @click="toAll" class="form-button"
				>查看全部案例</el-button
			>
		</div>
		<Partner />
		<RequestPurpose />
		<div v-if="QRcode" class="projectCase-contact">
			<div>联系我们</div>
			<img :src="QRcode" alt="" />
		</div>
		<div class="projectCase-movedRequest" v-if="showMovedRequest">
			<!-- <img src="@/assets/images/projectCaseFooter.png" alt=""> -->
			<!-- <div> -->
			<span class="btn-area">
				<el-button type="primary" @click="handleClickPurpose"
					>提交需求</el-button
				>&nbsp;
				<i class="el-icon-close" @click="showMovedRequest = false"></i>
			</span>
			<!-- </div> -->
			<!-- <div class="projectCase-movedRequest-wrap">
        <span><i class="tip-icon">!</i>还未找到想要的可视化案例？请告诉我们</span>
        <span>
          <el-button type="warning" round @click="handleClickPurpose">提交需求</el-button>&nbsp;
          <i class="el-icon-close" @click="showMovedRequest = false"></i>
        </span>
      </div> -->
		</div>
		<!-- <RequestForm v-if="showRequestForm" :showRequestForm.sync="showRequestForm"/>
    <VideoAnimate v-if="showVideoIndex !== ''" 
      :video.sync="videoUrl" 
      :showVideoIndex.sync="showVideoIndex" 
      :disabled="showVideoIndex === 0 ? 1 : showVideoIndex === list.length - 1 ? 2 : ''"/> -->
	</div>
</template>

<script>
import { mapState } from "vuex";
import EmptyPage from "@/components/EmptyPage";
import Partner from "@/components/Partner";
import ServiceCard from "./components/ServiceCard";
// import RequestForm from './components/RequestForm';
import RequestPurpose from "./components/RequestPurpose";
// import VideoAnimate from './components/VideoAnimate';
import { getFootByType } from "@/api/blackboard";
import { getBannerURL } from "@/api/common";
import { getProjectClass, getProject } from "@/api/projectCase";
import AliOSS from "ali-oss";
import { getOSSConfig } from "@/api/common";
export default {
	name: "ProjectCase",
	components: {
		EmptyPage,
		ServiceCard,
		RequestPurpose,
		// RequestForm,
		Partner,
		// VideoAnimate,
	},
	inject: ["backTop"],
	data: () => {
		const keyMap = ["行业领域", "页面元素"];
		const titleInfo = keyMap.map((item, index) => ({
			key: index,
			name: item,
			value: [
				{
					id: index,
					name: item,
					type: index,
				},
			],
		}));

		return {
			QRcode: null,
			loading: true,
			scrollLoading: false,

			showRequestForm: false, // 是否展示需求提交表单
			showMovedRequest: false, // 是否展示黄条提示
			pages: 1,
			// 搜索条件
			queryParam: {
				pageNum: 1,
				pageSize: 40,
				classId: "", // 分类ID
				type: "", // 分类类型
				classType: 3,
			},
			total: 0,
			serviceList: [], // 专业服务
			solutionList: [], // 解决方案
			projectList: [], // 项目案例
			banner: "", // banner图地址
			showVideoIndex: "", // 展示视频动画的项目索引
			videoUrl: "", // 展示视频动画的URL
			titleInfo: [
				{
					key: "",
					name: "代表案例",
				},
				...titleInfo,
			],
		};
	},
	computed: {
		...mapState("app", []),
	},
	watch: {
		// showVideoIndex() {
		//   if (this.showVideoIndex !== '') {
		//     this.videoUrl = this.list[this.showVideoIndex].files;
		//   }
		// },
	},
	created() {
		this.getBannerURL();
		this.getProjectClass();
		this.getProject();
		// this.getSolution();
		// this.getService();
		this.getFootByType();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener("scroll", this.scrollHandle, true);
		});
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.scrollHandle, true);
	},
	methods: {
		toAll() {
			window.open("#/projectCase/project/case");
		},
		/**
		 * 改变显示模式
		 */
		async getBuffer() {
			let config = await getOSSConfig();
			var client = new AliOSS({
				region: "oss-cn-chengdu",
				accessKeyId: config.data.accessid,
				accessKeySecret: "fEenefEpkSzxjT3wsIidFDHRHdslq9",
				bucket: "shuzixs",
				policy: config.data.policy,
				signature: config.data.signature,
				secure: true,
			});
			for (let i = 0; i < this.list.length; i++) {
				if (!this.list[i].files.startsWith("http")) {
					let url = await client.signatureUrl(this.list[i].files);

					this.$set(this.list[i], "files", url);
				}
			}
		},
		/**
		 * 页面滚动事件
		 */
		scrollHandle() {
			this.showMovedRequest = false;
		},
		/**
		 * 点击某一项目的视频动画展示
		 * @param id 项目ID
		 */
		handleClickShowVideo(id) {
			this.showVideoIndex = this.list.findIndex(item => item.id === id);
		},
		/**
		 * 点击提交需求
		 */
		handleClickPurpose() {
			this.showRequestForm = true;
		},
		initPageParams() {
			this.pageNum = 1;
			this.total = 0;
			this.pages = 1;
			this.serviceList = [];
		},
		/**
		 * 选择分类
		 */
		handleCommand(command) {
			let [type, classId] = ["", ""];

			if (command) {
				[type, classId] = command.split("~");
				const changedTitle = this.titleInfo.find(
					titleInfo => "" + titleInfo.key === "" + type
				);
				const changedClass = changedTitle.value.find(
					value => "" + value.id === "" + classId
				);

				changedTitle.name = changedClass.name;
				if (changedClass.id === changedClass.type) {
					classId = "";
				}
			} else {
				this.titleInfo.forEach(item => {
					if (item.value && item.value.length) {
						item.name = item.value[0].name;
					}
				});
			}
			this.queryParam.type = type;
			this.queryParam.classId = classId;
		},
		handlePageChange(pageNum) {
			this.queryParam.pageNum = pageNum;
			this.getProject();
		},
		getFootByType() {
			getFootByType({ type: 5 }).then(({ data }) => {
				this.QRcode = data;
			});
		},
		openBanner(imgUrl) {
			window.open(imgUrl);
		},
		/**
		 * 获取项目分类数据
		 */
		getProjectClass() {
			getProjectClass().then(({ data }) => {
				this.titleInfo.forEach(title => {
					if (title.key !== "") {
						title.value.push(...data.filter(item => +item.type === +title.key));
					}
				});
			});
		},
		/**
		 * 获取项目列表
		 */
		getProject() {
			try {
				this.showMovedRequest = false;
				getProject(this.queryParam).then(({ data, total }) => {
					this.projectList = data || [];
					this.pages = data.pages;
					this.total = total;
					// this.getBuffer();
					if (
						this.queryParam.pageNum !== 1 &&
						data.length < this.queryParam.pageSize
					) {
						this.showMovedRequest = true;
					}
					// this.backTop()
				});
			} catch (err) {
				throw err;
			} finally {
				this.loading = false;
				this.scrollLoading = false;
			}
		},

		/**
		 * 获取解决方案
		 */
		getSolution() {
			try {
				this.showMovedRequest = false;
				getProject({
					classType: 2,
				}).then(({ data, total }) => {
					this.solutionList = data || [];
				});
			} catch (err) {
				throw err;
			} finally {
				this.loading = false;
				// this.scrollLoading = false;
			}
		},

		/**
		 * 获取专业服务
		 */
		getService() {
			try {
				this.showMovedRequest = false;
				getProject({
					classType: 1,
				}).then(({ data, total }) => {
					this.serviceList = data || [];
				});
			} catch (err) {
				throw err;
			} finally {
				this.loading = false;
				// this.scrollLoading = false;
			}
		},

		/**
		 * 获取banner图地址
		 */
		getBannerURL() {
			getBannerURL(10).then(({ data }) => {
				this.banner = (data || []).splice(0, 2);
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.projectCase {
	min-width: 1200px;
	&-banner {
		text-align: center;
		font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
		> img {
			cursor: pointer;
			flex: 1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
			font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
		}
	}
	&-title {
		background-color: #fff;
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.03);
		text-align: center;
		/deep/ .el-dropdown-link {
			margin: 0 10px;
			@include font(#333, 20px, 600);
			cursor: pointer;
		}
		&-wrap {
			display: inline-block;
			padding: 20px 0;
			.title {
				margin-right: 10px;
				@include font(#333, 20px, 600);
				cursor: pointer;
			}
		}
	}
	&-body {
		margin: 0 auto 0 auto;
		width: 75.7%;
		min-width: 1130px;
		display: flex;
		justify-content: center;
		flex-direction: column;
		.projectCase-content {
			margin: 0 1.4%;
			width: 58.8%;
		}
		.form-button {
			padding: 10px 13px;
			border-radius: 50px;
			font-size: 20px;
			border: 1px solid #e07727;
			width: 240px;
			height: 62px;
			margin: 40px auto;
			background-color: #e07727;
			&:hover {
				border: 1px solid #e29050;
				background-color: #e29050;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
			}
		}
		&-wrap {
			padding-top: 30px;
			&-title {
				width: 100%;
				color: #333;
				font-size: 20px;
				margin: 0 0 20px 0;
				font-weight: 600;
				border-left: 6px solid #2f54eb;
				padding-left: 8px;
				height: 16px;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
			&-describe {
				color: #9da1b5;
				font-size: 18px;
				font-weight: 400;
			}
		}
		.projectCase-pagination {
			margin: 45px 0;
			text-align: center;
		}
	}
	&-contact {
		position: fixed;
		right: 5%;
		top: 50%;
		transform: translateY(-50%);
		padding: 10px;
		box-shadow: 0px 2px 4px 2px rgba(153, 154, 172, 0.1);
		border-radius: 4px;
		background-color: #fff;
		text-align: center;
		@include font(#333, 14px, 400);
		img {
			margin-top: 5px;
			width: 80px;
		}
	}
	&-movedRequest {
		position: fixed;
		bottom: 0;
		background: url("~@/assets/images/projectCaseFooter.png") no-repeat;
		font-size: 0;
		z-index: 1;
		width: calc(100% - 17px);
		min-width: calc(100% - 17px);
		height: 110px;
		.btn-area {
			position: absolute;
			bottom: 34px;
			right: 12%;
			font-size: 16px;
			color: rgba(153, 153, 153, 1);
		}
	}
}

.loading {
	margin: 20px 0;
	text-align: center;
	font-size: 32px;
}

// 小屏
@include mq($small) {
	.projectCase {
		&-body {
			width: 80%;
		}
		&-contact {
			right: 2%;
		}
		&-movedRequest {
			.btn-area {
				right: 9.7%;
			}
		}
	}
}
</style>
